import {Link} from '@primer/react'
import {AlertIcon} from './common/AlertIcon'
import {MergeBoxSectionHeader} from './common/MergeBoxSectionHeader'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import type {FailingRulesAndConditionPayload} from '../../types'

import styles from './BlockedSection.module.css'

export interface BlockedSectionProps {
  failingConditionsAndRules: FailingRulesAndConditionPayload[]
}

/**
 *
 * Describes why a pull request is unmergeable
 *
 * If the pull request is unmergeable, this component will render a section describing why
 */
export function BlockedSection({failingConditionsAndRules}: BlockedSectionProps) {
  return (
    <section aria-label="Merging is blocked" className="border-bottom borderColor-muted">
      <MergeBoxSectionHeader title="Merging is blocked" icon={<AlertIcon bgColor="var(--bgColor-danger-emphasis)" />}>
        <ul className="list-style-none">
          {failingConditionsAndRules.map(
            condition =>
              condition &&
              'message' in condition && (
                <li key={condition.displayName} className={styles.BlockedSectionMessage}>
                  <VerifiedHTMLText html={(condition.message || '') as SafeHTMLString} />{' '}
                  <AdditionalMessaging ruleName={condition.displayName} />
                </li>
              ),
          )}
        </ul>
      </MergeBoxSectionHeader>
    </section>
  )
}

function AdditionalMessaging({ruleName}: {ruleName: string}) {
  if (ruleName === 'UNVERIFIED_EMAIL') {
    return (
      <>
        You will be able to merge this pull request after you{' '}
        <Link href="/settings/emails" inline>
          verify your email address
        </Link>
        .
      </>
    )
  }

  return null
}

try{ BlockedSection.displayName ||= 'BlockedSection' } catch {}
try{ AdditionalMessaging.displayName ||= 'AdditionalMessaging' } catch {}